import request from '@/utils/request'

export default {
  // 登录
  login (redirectUrl, state) {
    return request.get(`/wx/login?redirectUrl=${redirectUrl}&state=${state}`)
      .then(res => res)
  },
  // 获取用户信息
  getUserInfo (code) {
    return request.get(`/wx/getUserInfo?code=${code}`)
      .then(res => res)
  },
  // 获取基地认证信息
  getBaseInfo () {
    return request.get(`/baseInfo/get`)
      .then(res => res)
  },
  // 获取用户信息
  getUserInfo2 () {
    return request.get(`/user/userInfo`)
      .then(res => res)
  }
}



// WEBPACK FOOTER //
// ./src/service/user.js